

























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import EventBus from '@/services/eventbus.service';
import {
  Getter,
  Mutation,
} from 'vuex-class';
import MiniMap from '@/components/map/MiniMap.vue';

@Component({
  components: {
    MiniMap,
    SvgIcon: {
      props: ['svg'],
      render(h: any): any {
        return h('div', { domProps: { innerHTML: (this as any).svg } });
      },
    },
  },
})
export default class MapWidget extends Vue {
  @Getter private hasPermission!: any;
  @Prop() private data!: any;
  @Prop() private container!: any;
  private siteData: any[] = [];
  private height: number = 0;
  private width: number = 0;
  private searchString: string = '';
  private open = false;
  private loading = true;

  private deviceSvg = '';
  private gatewaySvg = '';

  @Getter private widgetFilters!: string[];

  @Watch('container')
  private onContainerResize() {
    if (this.container && this.container.$el) {
      this.height = (this.container.$el as HTMLElement).offsetHeight - 90;
      this.width = (this.container.$el as HTMLElement).offsetWidth - 32;

    }
  }

  private createDeviceMarkerSVG() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 20 20');

    const outerRing = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    outerRing.setAttribute('cx', '10');
    outerRing.setAttribute('cy', '10');
    outerRing.setAttribute('r', '10');
    outerRing.setAttribute('fill', '#4CAF50');
    outerRing.setAttribute('opacity', '0.6');

    const innerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    innerCircle.setAttribute('cx', '10');
    innerCircle.setAttribute('cy', '10');
    innerCircle.setAttribute('r', '6');
    innerCircle.setAttribute('fill', 'rgba(255,255,255,0.6)');

    svg.appendChild(outerRing);
    svg.appendChild(innerCircle);

    this.deviceSvg = svg.outerHTML;
  }

  private createGatewayMarkerSVG() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '32');
    svg.setAttribute('height', '32');
    svg.setAttribute('viewBox', '0 0 32 32');

    const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    group.setAttribute('transform', 'translate(0, 0) rotate(45 16 16) scale(0.65)');

    const outerRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    outerRect.setAttribute('x', '6');
    outerRect.setAttribute('y', '6');
    outerRect.setAttribute('width', '24');
    outerRect.setAttribute('height', '24');
    outerRect.setAttribute('fill', '#4CAF50');
    outerRect.setAttribute('opacity', '0.6');

    const innerRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    innerRect.setAttribute('x', '10');
    innerRect.setAttribute('y', '10');
    innerRect.setAttribute('width', '16');
    innerRect.setAttribute('height', '16');
    innerRect.setAttribute('fill', 'rgba(255,255,255,0.6)');
    group.appendChild(outerRect);
    group.appendChild(innerRect);

    svg.appendChild(group);

    this.gatewaySvg = svg.outerHTML;
  }

  private clearSearch() {
    this.searchString = '';
    this.initFilters();
  }

  private doSearch() {
    if (this.searchString) {
      const lowercase = this.searchString.toLowerCase();

      const pins = this.siteData.filter((d: any) => d.siteName.toLowerCase().includes(lowercase));
      if (pins.length) {
        Vue.set(this, 'siteData', pins);
      } else {
        this.initFilters();
      }
    }
  }
  private mounted() {
    if (!this.open && this.$route.path.includes('map')) {
      // this.$router.replace('/dashboard')
      this.open = true;
    }
    EventBus.$on('filterByProject', this.filterBy);
    EventBus.$on('clearFilter', this.clearFilter);

    this.initFilters();
    this.onContainerResize();
    this.createDeviceMarkerSVG();
    this.createGatewayMarkerSVG();
  }

  private beforeDestroy() {
    EventBus.$off('filterByProject', this.filterBy);
    EventBus.$off('clearFilter', this.clearFilter);
  }

  private initFilters() {
    this.siteData = [...this.data.payload.devices];
    let filters = this.widgetFilters;
    filters = filters.filter((f: string) => f !== null);

    if (filters && filters.length) {
      const pins = this.siteData.filter((d: any) => filters.find((filter: string) => d.projectName === filter));

      Vue.set(this, 'siteData', pins);
    }
  }

  private filterBy(filter: string) {
    this.siteData = this.siteData.filter((d: any) => d.projectName === filter);
  }

  private clearFilter() {
    this.siteData = [...this.data.payload.devices];
  }
}
